import {
  TyckaConfig,
  SortOptions,
  ReviewResponse,
  ProductAverageRatingResponse,
} from '../types';

export class TyckaRestClient {
  private teamId: string;
  private projectId: string;
  private apiUrl: string;
  private restEndpoint: string;

  constructor(config: TyckaConfig) {
    this.teamId = config.teamId;
    this.projectId = config.projectId;
    this.apiUrl = config.apiUrl;
    this.restEndpoint = `${this.apiUrl}/${this.teamId}/${this.projectId}`;
  }

  public async fetchReviews(
    filter: { [key: string]: string },
    sortOptions: SortOptions[],
    pagination: { take: number; skip: number },
    lang: string,
    preview: boolean = false
  ) {
    const queryParams = [
      `facets=all`,
      this.buildFilterQuery(filter),
      this.buildPaginationQuery(pagination),
      this.buildSortQuery(sortOptions),
      `preview=${preview}`,
      `lang=${lang}`
    ]
      .filter(Boolean)
      .join('&');

    const response = await fetch(`${this.restEndpoint}/reviews?${queryParams}`);

    return (await response.json()) as ReviewResponse;
  }

  public async fetchAverageRating(
    filter: { [key: string]: string },
    strict?: boolean
  ) {
    const queryParams = [
      this.buildFilterQuery(filter),
      `strict=${strict || false}`,
    ]
      .filter(Boolean)
      .join('&');

    const response = await fetch(
      `${this.restEndpoint}/reviews/summary?${queryParams}`
    );

    return (await response.json()) as ProductAverageRatingResponse;
  }

  private buildSortQuery(sortOptions: SortOptions[]) {
    if (sortOptions.length === 0) {
      return '';
    }
    return `sort=${sortOptions.join('%2B')}`;
  }

  private buildPaginationQuery(pagination: { take: number; skip?: number }) {
    if (!pagination.take) {
      return '';
    }
    return `take=${pagination.take}&skip=${pagination.skip}`;
  }

  //#TODO  Search for a better method to detect the filters because not all filters are product related
  private buildFilterQuery(filter: { [key: string]: string }) {
    if (!filter || Object.keys(filter).length === 0) {
      return '';
    }

    const filters = Object.entries(filter)
      .map((e) => {
        if (e[1] === '') return;
        if (!e[0].toLocaleLowerCase().includes('.')) {
          return `product.${e[0]}:${e[1]}`;
        }
        return `${e[0]}:${e[1]}`;
      })
      .filter(Boolean)
      .join(',');
    return filters ? `filter=${filters}` : '';
  }
}
